/* Quick add: pick a variant from the product card and add it to the cart */
(() => {
  'use strict';
  const K = window.Kamo || {};
  let panel = null;
  const money = (c) => (K.formatMoney ? K.formatMoney(c) : '$' + (c / 100).toFixed(2));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const close = () => { if (panel) { panel.remove(); panel = null; } };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) { if (panel && !e.target.closest('.qa')) close(); return; }
    e.preventDefault();
    const handle = btn.dataset.quickAdd;
    if (panel && panel.dataset.handle === handle) { close(); return; }
    close();
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${K.routes && K.routes.root ? K.routes.root.replace(/\/$/, '') : ''}/products/${handle}.js`);
      if (!res.ok) throw new Error('no product');
      const p = await res.json();
      panel = document.createElement('div');
      panel.className = 'qa';
      panel.dataset.handle = handle;
      const label = (p.options || []).map((o) => (o.name ? o.name : o)).join(' / ');
      panel.innerHTML =
        `<p class="qa__t">${esc(label || 'Choose an option')}</p>` +
        `<div class="qa__list">` +
        p.variants
          .map((v) =>
            `<button type="button" class="qa__v" data-id="${v.id}"${v.available ? '' : ' disabled'}>` +
            `<span>${esc(v.title)}</span><em>${v.available ? money(v.price) : 'Sold out'}</em></button>`
          )
          .join('') +
        `</div>` +
        `<a class="qa__all" href="${p.url}">See full details</a>`;
      const card = btn.closest('.card') || btn.parentElement;
      card.appendChild(panel);
      panel.addEventListener('click', (ev) => {
        const v = ev.target.closest('[data-id]');
        if (!v || v.disabled) return;
        const fd = new FormData();
        fd.append('id', v.dataset.id);
        fd.append('quantity', 1);
        if (K.cart && K.cart.add) K.cart.add(fd, v);
        close();
      });
    } catch (err) {
      window.location.href = `/products/${handle}`;
    }
    btn.removeAttribute('aria-busy');
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  window.addEventListener('resize', close);
})();
